import { render, staticRenderFns } from "./WordEdit.vue?vue&type=template&id=76298a80&"
import script from "./WordEdit.vue?vue&type=script&lang=js&"
export * from "./WordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports